<template>
    <div class="swiper-container" ref="container">
        <!-- 内容主体 -->
        <div class="swiper-wrapper" ref="wrapper">
            <slot></slot>
        </div>
        <!-- v-if判断是否有分页，变化时会导致渲染不成功 -->
        <div v-show="isPagination" class="swiper-pagination"></div>
    </div>
</template>

<script>

	import Swiper from 'swiper'

	export default {
		name: '',
		props: {
			index: {
				type: Number,
				default: 0,
			},
			autoplay: {
				type: Number,
				default: 0
			},
			speed: {
				type: Number | String,
				default: 300
			},
			direction: {
				type: String,
				default: 'horizontal'
			},
			loop: {
				type: Boolean,
				default: false,
			},
			observer: {
				type: Boolean,
				default: false,
			},
			observeParents: {
				type: Boolean,
				default: false,
			},
			pagination: {
				type: [Object, Boolean],
				default() {
					return {}
				},
			}
		},
		mounted() {
			const context = this;
			let pagination = this.isPagination ? (typeof this.pagination === 'boolean' ? {el: '.swiper-pagination'} : {
				el: '.swiper-pagination',
				...this.pagination
			}) : false;


			this.swiper = new Swiper(this.$refs.container, {
				// Slides的滑动方向，可设置水平(horizontal)或垂直(vertical)。
				direction: this.direction,
				// 切换速度，即slider自动滑动开始到结束的时间（单位ms），也是触摸滑动时释放至贴合的时间。
				speed: this.speed,
				on: {
					// 当前Slide切换时执行(activeIndex发生改变)
					slideChange() {
						context.$emit('change', this);
						context.$emit('update:index', this.activeIndex);
					},
					click() {
						context.$emit('click', this);
					}
				},
				autoplay: this.autoplay ? {
					// 自动切换的时间间隔，单位ms
					delay: this.autoplay,
					// 如果设置为true，当切换到最后一个slide时停止自动切换。（loop模式下无效）。
					stopOnLastSlide: false,
					// 用户操作swiper之后，是否禁止autoplay。默认为true：停止。
					disableOnInteraction: false,
				} : false,
				loop: this.loop,
				pagination: pagination,
				observer: this.observer,//修改swiper自己或子元素时，自动初始化swiper
				observeParents: this.observeParents,//修改swiper的父元素时，自动初始化swiper
			});

			if (this.index) {
				this.swiper.slideTo(this.index);
			} else {
				context.$emit('change', this.$refs.container);
			}
		},
		data() {
			return {
				isPagination: typeof  this.pagination === 'boolean' ? this.pagination : !!Object.keys(this.pagination).length,
			}
		},
		watch: {
			index(index) {
				if (!this.swiper) return;
				this.swiper.slideTo(index || 0)
			},
            pagination(newVal, oldVal) {
                // 监听是否有pagination
                this.isPagination = newVal;
                if(!newVal) this.swiper.slideTo(0);
            }
		}
	}
</script>

<style lang="scss" scoped>
    @import "~swiper/dist/css/swiper.css";

    /deep/ .swiper-pagination-bullets {
        left: 50%;
        transform: translateX(-50%) !important;
        white-space: nowrap;
        .swiper-pagination-bullet{
            margin: 0 4px;
        }
    }

    .swiper-container, .swiper-wrapper {
        width: 100%;
        height: 100%;
    }
</style>